const BarChart2 = [
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  },
  [
    ["line", { x1: "18", y1: "20", x2: "18", y2: "10" }],
    ["line", { x1: "12", y1: "20", x2: "12", y2: "4" }],
    ["line", { x1: "6", y1: "20", x2: "6", y2: "14" }]
  ]
];

export default BarChart2;
